import type { ComponentProps } from 'react';
import { useAuiState } from '@assistant-ui/react';
import { ToolFallback } from '@/components/assistant-ui/tool-fallback';
import { WorkspaceToolCard, WorkspaceOutputCard, isWorkspaceToolName } from './tool-cards';
import { ToolSourceLabel } from './chat-collaboration-thread';

/** A tool call in a company chat: the workspace's own card for its tools, the
 * generic card for everything else, and under either one "From Anna's Gmail"
 * when the result came from someone else's private account (collaboration
 * v1). ui/app.tsx and the UI tests mount this same component. */
export function WorkspaceNativeTool(props: ComponentProps<typeof ToolFallback>) {
  const messageId = useAuiState((state) => state.message.id);
  return (
    <>
      <WorkspaceOutputCard
        toolName={props.toolName}
        toolCallId={props.toolCallId}
        messageId={messageId}
        result={props.result}
        fallback={
          isWorkspaceToolName(props.toolName) ? (
            <WorkspaceToolCard {...props} />
          ) : (
            <ToolFallback {...props} />
          )
        }
      />
      <ToolSourceLabel toolCallId={props.toolCallId} />
    </>
  );
}
